import { PrintIframeService } from '../../../services/print/print-iframe.service';
import { IMAGE_KEYS, ImageStorageService } from '../../../services/storage/image-storage.service';

export default {
  data() {
    return {
      sportName: '',
      logo: '',

      layoutSetting: 0, // 0 - horizontal; 1 - vertical;
      fontSizeSetting: 0, // 0 - normal; 1 - large;

      loadingCursor: false,
    };
  },
  created() {
    const imageStore = new ImageStorageService();
    imageStore.getImage(IMAGE_KEYS.CATEGORY_PRINT).then(imageItem => {
      this.logo = imageItem.image;
    });
    this.sportName = this.$store.getters.getSportName(this.tournamentData.sportId);
  },
  computed: {
    maxOutcomesPerPage() {
      return !this.layoutSetting ? 20 : 10;
    },
    getPrintStyle() {
      return `
        body{
          margin: 0;
        }
        @page{
          size: ${!this.layoutSetting ? 'A4 landscape' : 'A4'};
          margin: 0;
        }
        table{
          border-collapse: collapse;
          page-break-after: always;
          /* word-break: break-word; */
          margin: 10px;
          width: calc(100% - 20px);
          max-height: calc(100% - 20px);
        }
        table *{
          font-size: ${!this.fontSizeSetting ? '10px' : '12px'};
          font-family: sans-serif;
        }
        .print-logo{
          text-align: left;
        }
        .print-logo img{
          height: 100px;
          max-width: 100%;
        }
        .text-left{
          text-align: left;
        }
        hr{
          border: 0.5px solid gray;
        } 
      `;
    },
  },
  methods: {
    async printData() {
      const compStyle = this.getPrintStyle;

      const component = await this.generatePrintPage().catch(e => {
        console.error(e); // eslint-disable-line
      });

      // we need to check if because generetePrintPage can throw error and not return component
      if (component) {
        const printIframe = new PrintIframeService();
        printIframe.addComponentStyle(compStyle);
        printIframe.printComponent(component);
      }
    },
    async downloadExcel() {
      if (this.loadingCursor) {
        return;
      }

      this.loadingCursor = true;

      // this.generatePrintPage should be implemented by components using this mixin
      const component = await this.generatePrintPage().catch(e => {
        console.error(e); // eslint-disable-line
      });

      // we need to check if because generetePrintPage can throw error and not return component
      if (component) {
        let excelDownloadElement = document.getElementById('excelDownloadElement');
        component.$mount();
        let excelData = 'data:application/vnd.ms-excel,' + encodeURIComponent(component.$el.outerHTML); // table.outerHTML
        excelDownloadElement.href = excelData;
        excelDownloadElement.click();
      }
      this.loadingCursor = false;
    },
  },
};
